import * as z from "zod";

export const OutcomeCountSchema = z.object({
  outcome: z.string(),
  count: z.number(),
});

export type OutcomeCount = z.infer<typeof OutcomeCountSchema>;

export const getReturnsItemsByOutcome = {
  name: "getReturnsItemsByOutcome" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    merchantTeamId: z.string().optional(),
  }),
  output: z.object({ outcomes: z.array(OutcomeCountSchema) }),
};
